<template>
  <div class="entry-page">
    <div class="entry-card">
      <header class="entry-header">
        <h1>Aplikasi Psikotes</h1>
        <p>Silahkan isi data diri untuk melanjutkan Tes</p>
      </header>
      
      <main class="entry-main">
        <!-- ====================================================== -->
        <!-- LANGKAH 1: Masukkan Kode Tes -->
        <!-- ====================================================== -->
        <form v-if="step === 'enter_code'" @submit.prevent="validateCode">
          <div class="form-group">
            <label for="access-code">Kode Tes</label>
            <input
              id="access-code"
              v-model="accessCode"
              type="text"
              placeholder="Contoh: RAHASIA123"
              required
              :class="{ 'is-invalid': error && step === 'enter_code' }"
            />
          </div>
          <button type="submit" :disabled="isLoading" class="button-primary">
            {{ isLoading ? 'Memeriksa...' : 'Lanjutkan' }}
          </button>
        </form>

        <!-- ====================================================== -->
        <!-- LANGKAH 2: Pilih Jalur (Peserta Baru / Lanjutkan) -->
        <!-- ====================================================== -->
        <div v-if="step === 'choose_path'" class="path-chooser">
          <h2>Paket Tes: {{ packageName }}</h2>
          <p>Apakah Anda peserta baru atau ingin melanjutkan sesi yang sudah ada?</p>
          <div class="button-group">
            <button @click="setStep('new_participant')" class="button-secondary">Saya Peserta Baru</button>
            <button @click="setStep('resume_session')" class="button-primary">Lanjutkan Sesi</button>
          </div>
        </div>

        <!-- ====================================================== -->
<!-- LANGKAH 3A: Form Peserta Baru (DIPERBARUI) -->
<!-- ====================================================== -->
<form v-if="step === 'new_participant'" @submit.prevent="createSession">
  <h2>Pendaftaran Peserta Baru</h2>
  
  <!-- Baris 1: Nama & NIK -->
  <div class="form-row">
    <div class="form-group">
      <label for="name">Nama Lengkap *</label>
      <input id="name" v-model="participant.name" type="text" placeholder="Sesuai KTP" required />
    </div>
    <div class="form-group">
      <label for="test-number">NIK / No. Peserta *</label>
      <input id="test-number" v-model="participant.test_number" type="text" placeholder="Sesuai KTP" required />
    </div>
  </div>

  <!-- Baris 2: Tanggal Lahir & No HP -->
 <div class="form-row">
        <div class="form-group">
          <label for="birth-date">Tanggal Lahir *</label>
          <input 
            id="birth-date" 
            v-model="participant.birth_date" 
            type="date"
            :class="{ 'is-invalid': error && step === 'new_participant' && participant.birth_date && !isValidDate(participant.birth_date) }" required
          />
        </div>
    <div class="form-group">
      <label for="reg-number">No Handphone</label>
      <input id="reg-number" v-model="participant.registration_number" type="tel" placeholder="Contoh: 0812..." required />
    </div>
  </div>

  <!-- Baris 3: Pekerjaan & Alamat -->
  <div class="form-row">
    <div class="form-group">
      <label for="job">Pekerjaan</label>
      <input id="job" v-model="participant.job" type="text" placeholder="Contoh: Karyawan Swasta" />
    </div>
    <div class="form-group">
      <label for="address">Alamat *</label>
      <textarea id="address" v-model="participant.address" placeholder="Sesuai KTP" rows="1" required></textarea>
    </div>
  </div>
  
  <!-- ============================================ -->
  <!--               FIELD BARU DI SINI             -->
  <!-- ============================================ -->
  
  <hr class="form-divider">

  <!-- Baris 4: Tipe SIM & Status -->
  <div class="form-row">
  <div class="form-group">
    <label for="sim-type">Level Penddidikan *</label>
    <select id="sim-type" v-model="participant.sim_type" required>
      <option disabled value="">-- Level Pendidikan --</option>
      <!-- PERBARUI v-for INI -->
      <option v-for="type in simTypes" :key="type.value" :value="type.value">
        {{ type.text }}
      </option>
    </select>
  </div>
  <div class="form-group">
    <label for="sim-status">Keperluan *</label>
    <select id="sim-status" v-model="participant.sim_status" required>
      <option disabled value="">-- Pilih Keperluan --</option>
      <!-- PERBARUI v-for INI -->
      <option v-for="status in simStatuses" :key="status.value" :value="status.value">
        {{ status.text }}
      </option>
    </select>
  </div>
</div>
  
  <div class="form-row">
  <div class="form-group full-width">
    <label for="test-location">Lokasi Tes *</label>
    
    <!-- HAPUS INPUT LAMA INI: -->
    <!-- <input id="test-location" v-model="participant.test_location" ... /> -->

    <!-- GANTI DENGAN KOMPONEN MULTISELECT INI: -->
    <Multiselect
      id="test-location"
      v-model="participant.test_location"
      :options="allGerai"
      :searchable="true"
      placeholder="Ketik untuk mencari atau pilih lokasi tes"
      no-options-text="Tidak ada lokasi ditemukan. Ketik untuk menambah."
      :create-option="true"
      required
    />
    
  </div>
</div>

  <!-- ============================================ -->
  
  <div class="form-actions">
    <button type="submit" :disabled="isLoading" class="button-primary">
      {{ isLoading ? 'Memproses...' : 'Daftar & Mulai' }}
    </button>
    <button type="button" class="button-link" @click="setStep('choose_path')">Kembali</button>
  </div>
</form>

 <!-- ====================================================== -->
        <!--  TAMBAHKAN BLOK YANG HILANG INI KEMBALI DI SINI        -->
        <!-- ====================================================== -->
        <form v-if="step === 'resume_session'" @submit.prevent="resumeSession">
          <h2>Lanjutkan Sesi</h2>
          <div class="form-group">
            <label for="resume-test-number">NIK / No Peserta *</label>
            <input 
              id="resume-test-number" 
              v-model="resumeTestNumber" 
              type="text" 
              placeholder="Masukkan NIK / No Peserta Anda"
              required
              :class="{ 'is-invalid': error && step === 'resume_session' && !resumeTestNumber }"
            />
          </div>
          <div class="form-actions">
            <button type="submit" :disabled="isLoading" class="button-primary">
              {{ isLoading ? 'Mencari...' : 'Lanjutkan' }}
            </button>
            <button type="button" class="button-link" @click="setStep('choose_path')">Kembali</button>
          </div>
        </form>
        
        <p v-if="error" class="error-message">{{ error }}</p>
      </main>
      
    </div>
  </div>
</template>


<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import apiClient from '@/services/api.js';

import Multiselect from '@vueform/multiselect';

const router = useRouter();

// --- State Management ---
const step = ref('enter_code');
const isLoading = ref(false);
const error = ref('');

// --- Data Models ---
const accessCode = ref('');
const packageName = ref('');
const resumeTestNumber = ref('');

// --- 1. PERBARUI MODEL 'participant' ---
const participant = ref({
  name: '',
  test_number: '', // Ini NIK
  birth_date: null,
  registration_number: '', // Ini No Handphone
  job: '',
  address: '',
  sim_type: '', // BARU: Tipe SIM
  sim_status: '', // BARU: Baru / Perpanjangan
  test_location: '' // BARU: Lokasi Tes
});


// --- 2. TAMBAHKAN DATA UNTUK DROPDOWN ---
// Array objek untuk Jenis Golongan SIM
const simTypes = [
  { value: 'Lulus SMA/SMK/MA', text: 'lulus SMA/SMK/MA' },
  { value: 'Lulus S1', text: 'Lulus S1' },
  { value: 'Lulus S2', text: 'Lulus S2' },
  { value: 'Lulus S3', text: 'Lulus S3' },
];

// Array objek untuk Keperluan SIM
const simStatuses = [
  { value: 'Tes Minat', text: 'Tes Minat' },
  { value: 'Tes Minat Bakat', text: 'Tes Minat Bakat' },
  { value: 'Kenaikan Tingkat', text: 'Kenaikan Tingkat' },
  { value: 'Ujicoba', text: 'Ujicoba' },
];
// ------------------------------------
// --- 2. TAMBAHKAN STATE BARU UNTUK DAFTAR GERAI ---
const allGerai = ref([]);

// --- 3. BUAT FUNGSI UNTUK MENGAMBIL DATA GERAI ---
const fetchAllGerai = async () => {
  try {
    // Kita tidak butuh otentikasi untuk ini, jadi kita bisa buat endpoint publik
    // atau gunakan yang sudah ada jika tidak masalah.
    // Asumsi kita buat endpoint baru: GET /gerai
    const response = await apiClient.get('/gerai'); // Panggil endpoint gerai
    // Kita butuh format [{ value: 'Nama Gerai', label: 'Nama Gerai' }]
    allGerai.value = response.data.map(gerai => ({
      value: gerai.name,
      label: gerai.name
    }));
  } catch (err) {
    console.error("Gagal memuat daftar gerai untuk autocomplete:", err);
    // Biarkan kosong jika gagal, user masih bisa mengetik manual
  }
};

// --- Methods ---
const setStep = (newStep) => {
  error.value = '';
  step.value = newStep;
};

const isValidDate = (dateString) => {
  const date = new Date(dateString);
  return !isNaN(date.getTime());
};

const handleSuccessfulLogin = (data) => {
  localStorage.setItem('session_token', data.session_token);
  // Hapus data lama yang mungkin tidak relevan
  localStorage.removeItem('test_info');
  router.push({ name: 'TestDashboard' });
};

const handleError = (err, defaultMessage) => {
  if (err.response && err.response.data && err.response.data.detail) {
    error.value = err.response.data.detail;
  } else {
    error.value = defaultMessage;
  }
  console.error(err);
};

const validateCode = async () => {
  isLoading.value = true;
  error.value = '';
  try {
    const response = await apiClient.post('/packages/validate', { access_code: accessCode.value });
    if (response.data.valid) {
      packageName.value = response.data.package_name;
      setStep('choose_path');
    } else {
      error.value = 'Kode tes tidak valid atau tidak aktif.';
    }
  } catch (err) {
    handleError(err, 'Terjadi kesalahan saat memeriksa kode.');
  } finally {
    isLoading.value = false;
  }
};

const createSession = async () => {
  isLoading.value = true;
  error.value = '';
  try {
    // Payload sudah otomatis berisi field baru karena kita menggunakan spread operator
    const payload = {
      access_code: accessCode.value,
      ...participant.value,
    };
    const response = await apiClient.post('/sessions/create', payload);
    handleSuccessfulLogin(response.data);
  } catch (err) {
    handleError(err, 'Gagal membuat sesi. Periksa kembali data Anda. Semua field bertanda * wajib diisi.');
  } finally {
    isLoading.value = false;
  }
};

const resumeSession = async () => {
  isLoading.value = true;
  error.value = '';
  try {
    const payload = {
      access_code: accessCode.value,
      test_number: resumeTestNumber.value
    };
    const response = await apiClient.post('/sessions/resume', payload);
    if (response.status === 200) {
      handleSuccessfulLogin(response.data);
    }
  } catch (err) {
    handleError(err, 'Gagal melanjutkan sesi. Periksa kembali Nomor Tes Anda.');
  } finally {
    isLoading.value = false;
  }
};

onMounted(() => {
  fetchAllGerai();
  const previewCode = localStorage.getItem('preview_access_code');
  if (previewCode) {
    accessCode.value = previewCode;
    localStorage.removeItem('preview_access_code');
    validateCode();
  }
});
</script>


<style scoped>
.entry-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f0f2f5;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.entry-card {
  width: 100%;
  max-width: 480px;
  padding: 40px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.entry-header {
  text-align: center;
  margin-bottom: 30px;
}

.entry-header h1 {
  margin: 0 0 10px 0;
  font-size: 24px;
  color: #333;
}

.entry-header p {
  margin: 0;
  color: #666;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #555;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-sizing: border-box;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #1abc9c;
  box-shadow: 0 0 0 2px rgba(26, 188, 156, 0.2);
}

.form-group input.is-invalid,
.form-group textarea.is-invalid {
  border-color: #e74c3c;
  box-shadow: 0 0 0 2px rgba(231, 76, 60, 0.2);
}

.form-group input::placeholder,
.form-group textarea::placeholder {
  color: #aaa;
}

/* Layout dua kolom */
.form-row {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.form-row .form-group {
  flex: 1;
}

.form-row .form-group:last-child {
  margin-bottom: 0;
}

/* Tombol */
.button-primary {
  background-color: #1abc9c;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 12px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s;
  width: 100%;
}

.button-primary:hover {
  background-color: #16a085;
}

.button-secondary {
  background-color: #ecf0f1;
  color: #2c3e50;
  border: 1px solid #bdc3c7;
  border-radius: 6px;
  padding: 12px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s;
  width: 100%;
}

.button-secondary:hover {
  background-color: #bdc3c7;
}

.button-link {
  background: none;
  color: #777;
  text-decoration: none;
  font-size: 14px;
  padding: 12px;
  width: 100%;
  text-align: center;
  margin-top: 10px;
  transition: color 0.2s;
}

.button-link:hover {
  color: #2c3e50;
  text-decoration: underline;
}

.form-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
}

.error-message {
  color: #e74c3c;
  margin-top: 15px;
  text-align: center;
}

.entry-footer {
  text-align: center;
  margin-top: 30px;
  border-top: 1px solid #eee;
  padding-top: 20px;
}

.entry-footer a {
  color: #777;
  text-decoration: none;
  font-size: 14px;
}
.entry-footer a:hover {
  text-decoration: underline;
}

.path-chooser { text-align: center; }
.button-group { margin-top: 20px; display: flex; flex-direction: column; gap: 10px; }

/* Responsif */
@media (max-width: 480px) {
  .form-row {
    flex-direction: column;
    gap: 20px;
  }
  .entry-card {
    padding: 20px;
    margin: 20px;
  }
}


/* Tambahkan ini di dalam <style scoped> */
.form-divider {
  border: none;
  border-top: 1px solid #e0e0e0;
  margin: 25px 0;
}

.form-group.full-width {
  flex: 1 1 100%;
}

/* Sedikit penyesuaian untuk textarea agar tidak terlalu tinggi */
textarea {
  resize: vertical;
}

@import '@vueform/multiselect/themes/default.css';

/* (Opsional) Sesuaikan tampilan agar cocok dengan tema Anda */
:root {
  --ms-tag-bg: #1abc9c;
  --ms-option-bg-pointed: #e8f8f5;
  --ms-option-color-pointed: #16a085;
}

</style>